import React, { Component } from "react";

import LocaleContext from "./LocaleContext";
import { DEFAULT_LOCALE } from "./locale";
import { getTranslator } from "./translate";

class ApplicationLocaleProvider extends Component {
  componentDidMount() {
    this.setDocumentLanguage(this.props.locale);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      this.setDocumentLanguage(this.props.locale);
    }
  }

  componentWillUnmount() {
    this.setDocumentLanguage(DEFAULT_LOCALE);
  }

  // Keeps the browser from offering to translate a page that is already in
  // the merchant's language.
  setDocumentLanguage = locale => {
    document.documentElement.lang = locale;
  };

  render() {
    return (
      <LocaleContext.Provider value={getTranslator(this.props.locale)}>
        {this.props.children}
      </LocaleContext.Provider>
    );
  }
}

export default ApplicationLocaleProvider;
